export const REVENUE_ROUTES = {
  LIST: '/revenue',
} as const;
